module.exports = __webpack_public_path__ + "static/img/bg.7869298.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg.png
// module id = 93PC
// module chunks = 1